export default __webpack_public_path__ + "static/media/deer-tree-sprig.2aa3cf7b.png";